import { render } from "./DADataTableLazy2 copy.vue?vue&type=template&id=139089d1"
import script from "./DADataTableLazy2 copy.vue?vue&type=script&lang=js"
export * from "./DADataTableLazy2 copy.vue?vue&type=script&lang=js"

import "./DADataTableLazy2 copy.vue?vue&type=style&index=0&id=139089d1&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__